"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegistered = getRegistered;
exports.runChecks = runChecks;
exports.confirmUnload = confirmUnload;
exports.confirmNavigation = confirmNavigation;
exports.enforceFunction = enforceFunction;
exports.register = register;
exports.unregister = unregister;
exports.clearRegistrations = clearRegistrations;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _q = _interopRequireDefault(require("q"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _NavigationConfirmPrompt = require("./NavigationConfirmPrompt");

// NavigationConfirmation is a registry of callbacks which are executed
// when the user navigates to another page.
//
// If one or more of the registered callbacks return a warning message,
// they will be prompted with that message before leaving.
//
// For example...
//
//   ```
//   getNavigationConfirmation() {
//     if (!hasChanges) {
//       return;
//     }
//     return I18n.text('unsavedChangesWarning');
//   }
//
//
//   componentWillMount() {
//     register(this.handleGetNavigationConfirmation);
//   }
//   ```
//
// It's important to unregister your callback once it's no longer needed...
//
//   ```
//   componentWillUnmount() {
//     unregister(this.handleGetNavigationConfirmation);
//   }
//   ```
var registered = (0, _immutable.OrderedSet)();

function getRegistered() {
  return registered;
}

function runChecks() {
  return registered.reduce(function (confirmations, checker) {
    var message = checker();

    if (message == null) {
      return confirmations;
    }

    confirmations.push(message);
    return confirmations;
  }, []);
}
/*
   * This is meant to be used as a handler for window.onbeforeunload.
   *
   * @param  {BeforeUnloadEvent}
   * @return {?string}
   */


function confirmUnload(evt) {
  (0, _invariant.default)(evt != null && (0, _typeof2.default)(evt) === 'object', 'expected `evt` to be an object but got `%s`', evt);
  var confirmations = runChecks();

  if (confirmations.length === 0) {
    return undefined;
  }

  return evt.returnValue = confirmations.join('\n\n');
}
/*
   * Used for confirming navigation other routes within the app.
   *
   * @return {Promise}
   */


function confirmNavigation() {
  var confirmations = runChecks();

  if (confirmations.length === 0) {
    return _q.default.Promise.resolve(true);
  }

  return (0, _NavigationConfirmPrompt.getConfirmPrompt)()({
    description: confirmations.map(function (message, i) {
      return _react.default.createElement("span", {
        className: "display-block m-bottom-2",
        key: i
      }, message);
    }),
    message: _I18n.default.text('customerDataUiUtilities.NavigationConfirmation.abandonChanges.title'),
    confirmLabel: _I18n.default.text('customerDataUiUtilities.NavigationConfirmation.abandonChanges.leave'),
    rejectLabel: _I18n.default.text('customerDataUiUtilities.NavigationConfirmation.abandonChanges.stay')
  });
}

function enforceFunction(checker) {
  (0, _invariant.default)(typeof checker === 'function', 'expected `checker` to be a function but got `%s`', checker);
  return checker;
}
/*
   * Add a callback to be checked before navigation.
   * Throws if `checker` is not a function.
   *
   * `checker` should return either `undefined` (if no confirmation is needed)
   * or a translated string describing the changes that will be lost if the
   * user proceeds to navigate away from the certain page.
   *
   * @param  {() => ?string}
   * @return {void}
   */


function register(checker) {
  registered = registered.add(enforceFunction(checker));
}
/*
   * Remove a callback that was previously registered.
   * Throws if `checker` is not a function.
   *
   * @param  {() => ?string}
   * @return {void}
   */


function unregister(checker) {
  registered = registered.remove(enforceFunction(checker));
}

function clearRegistrations() {
  registered = (0, _immutable.OrderedSet)();
}